import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-2, message, chat"><path d="M18.252 3C20.323 3 22.002 4.67893 22.002 6.75V15.25C22.002 17.3211 20.323 19 18.252 19H12.1946L7.36339 21.6572C7.13105 21.785 6.84849 21.7806 6.62023 21.6456C6.39198 21.5106 6.25195 21.2652 6.25195 21V19H5.75195C3.68089 19 2.00195 17.3211 2.00195 15.25V6.75C2.00195 4.67893 3.68089 3 5.75195 3H18.252Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubble2;
